import { platformAdminIdentityCustomFields } from "./platform-admin-identity-custom-fields";
import { platformAdminIdentityOrganizationTree } from "./platform-admin-identity-organization-tree";
import { platformAdminIdentityUserWorkflows } from "./platform-admin-identity-user-workflows";
import { platformAdminIdentityValues } from "./platform-admin-identity-values";
import { platformAdminIdentityWorkflows } from "./platform-admin-identity-workflows";
export const platformAdminIdentity = {
  duration1Day: "1天",
  duration1Week: "1周",
  duration1Month: "1月",
  duration1Year: "1年",

  title: "统一身份",
  subtitle: "统一查看身份状态与治理动作。",
  directRead: "当前已直接读取 sso-center 的统一身份主数据，并且写操作也直接落到统一身份中心。",
  indirectRead:
    "当前会话不是统一身份登录，这页只展示链路状态。切到统一身份登录后，才能直读和维护平台身份主数据。",
  loadFailed: "统一身份数据读取失败",
  summaryMode: "认证模式：{value}",
  summarySso: "SSO 状态：{value}",
  summaryUsers: "活跃用户：{count}",
  summaryApps: "身份接入应用：{count}",
  summaryTenants: "租户：{count}",
  summaryOrgs: "组织：{count}",
  summaryRoles: "平台角色：{count}",
  authCardTitle: "认证模式",
  authModeCurrent: "当前 auth_mode",
  ssoTarget: "SSO 代理目标",
  identityDomain: "统一身份域名",
  consoleCardTitle: "身份控制台信息",
  links: {
    portal: "门户",
    platformAdmin: "平台后台",
  },
  menu: {
    identity: "身份治理",
    userCustomFields: "用户自定义字段",
  },
  common: {
    pageNotFound: "页面不存在。",
    backToIdentity: "返回身份中心",
  },
  login: {
    pageTitle: "{platformName} · 统一身份",
    summary: "平台管理类工作台统一通过统一身份接管当前会话，再进入对应控制面。",
    maintenanceNotice: "统一身份控制台维护中，部分治理能力可能暂不可用。",
    noAccess: "当前统一身份没有身份控制台访问权限。",
  },
  dashboard: {
    title: "身份概览",
    subtitle: "统一查看身份状态与治理动作。",
    cards: {
      applications: "应用接入治理",
      users: "平台用户治理",
      roles: "角色与权限治理",
    },
  },
  overview: {
    kpiActiveUsers: "活跃用户",
    kpiApplications: "接入应用",
    kpiTenants: "租户",
    kpiOrganizations: "组织",
    kpiRoles: "平台角色",
    kpiCriticalRisks: "重大风险",
    accessStatusTitle: "接入与认证状态",
    masterDataTitle: "身份主数据规模",
    riskTitle: "治理风险",
    metricSsoStatus: "SSO 状态",
    metricBlockedApplications: "阻断应用",
    metricDegradedApplications: "降级应用",
    metricCredentialIssues: "凭据异常应用",
    recentEventsSubtitle: "最近 8 条身份治理事件",
  },
  sections: {
    applications: {
      title: "身份接入应用",
      subtitle: "统一维护身份接入应用、授权规则与角色映射。",
    },
    tenants: {
      title: "租户",
      subtitle: "统一维护租户主数据与治理边界。",
    },
    organizations: {
      title: "组织",
      subtitle: "统一维护组织树、节点成员与组织归属。",
    },
    users: {
      title: "平台用户",
      subtitle: "统一维护平台用户、角色映射与应用上下文。",
    },
    userCustomFields: {
      title: "用户自定义字段",
      subtitle: "统一维护平台用户扩展字段定义。",
    },
    roles: {
      title: "平台角色",
      subtitle: "统一维护平台角色字典与默认治理边界。",
    },
    permissions: {
      title: "权限点",
      subtitle: "统一维护权限点字典与权限绑定。",
    },
    events: {
      title: "身份审计",
      subtitle: "追溯谁在什么时候对什么身份对象执行了什么治理操作。",
    },
    loginRecords: {
      title: "登录记录",
      subtitle: "查看真实登录尝试、结果、来源 IP 与客户端环境信息。",
    },
  },
  objects: {
    application: "身份接入应用",
    organizationUnit: "组织节点",
    grant: "准入规则",
    roleMapping: "角色映射",
    permissionBinding: "权限绑定",
    tenant: "租户",
    user: "用户",
    role: "平台角色",
    permission: "权限点",
    userCustomField: "用户自定义字段",
  },
  roleLabels: {
    platform_admin: "平台管理员",
    intelligence_admin: "智能中心管理员",
    identity_admin: "身份管理员",
    asset_admin: "资产管理员",
    asset_editor: "资产编辑员",
    execution_admin: "执行管理员",
    environment_admin: "环境管理员",
    environment_designer: "环境设计者",
    tactics_techniques_admin: "技战法中心管理员",
    capability_graph_admin: "能力图谱管理员",
    vulnerability_library_admin: "漏洞信息库管理员",
    business_reference_admin: "业务引用中心管理员",
    traffic_library_admin: "流量库管理员",
    platform_operator: "平台运维",
    auditor: "审计员",
    harbor_admin: "Harbor 管理员",
    redblue_admin: "红蓝对抗管理员",
    redblue_activity_manager: "红蓝活动管理员",
    admin: "管理员",
    user: "用户",
    owner: "负责人",
    tester: "测试员",
    student: "学员",
    candidate: "考生",
    question_editor: "题库编辑",
    exam_manager: "考试管理员",
    reviewer: "阅卷员",
    proctor: "监考员",
  },
  fallbackPermissions: {
    consoleReadName: "打开身份控制台",
    consoleReadDescription: "查看统一身份治理控制台总览与当前状态。",
    identityReadName: "打开身份中心",
    identityReadDescription: "查看统一身份、应用、租户、组织与用户上下文。",
    identityManageName: "管理身份中心",
    identityManageDescription: "维护平台角色、权限点、绑定、租户、组织和应用接入规则。",
    assetReadName: "打开资产中心",
    assetReadDescription: "查看资产、对象空间与引用关系。",
    assetManageName: "管理资产中心",
    assetManageDescription: "维护资产、上传策略和对象空间授权。",
    executionReadName: "打开执行底座",
    executionReadDescription: "查看实例、任务和镜像执行状态。",
    executionManageName: "管理执行底座",
    executionManageDescription: "维护实例、运行资源和执行任务。",
    auditReadName: "打开平台审计",
    auditReadDescription: "查看登录日志、操作日志和平台审计记录。",
  },
  roleModel: "平台角色模型",
  componentTitle: "统一身份组件",
  openSso: "打开 SSO",
  footerNote:
    "统一身份页现在直接维护 sso-center 的身份接入应用、租户、组织、平台角色字典、权限点、平台角色绑定、权限绑定、应用角色映射，并提供身份治理事件追踪。",
  tabs: {
    applications: "身份接入应用 ({count})",
    tenants: "租户 ({count})",
    organizations: "组织 ({count})",
    users: "平台用户 ({count})",
    userCustomFields: "用户自定义字段 ({count})",
    roles: "平台角色 ({count})",
    permissions: "权限点 ({count})",
    events: "身份审计",
    loginRecords: "登录记录",
  },
  tables: {
    applications: "身份接入应用",
    tenants: "租户",
    organizations: "组织",
    roleDict: "平台角色字典",
    permissionDict: "权限点字典",
    applicationGrantRules: "应用准入规则",
    applicationRoleMappings: "应用角色映射",
    credentials: "接入凭据",
    applicationAccess: "应用访问",
    businessRoleMatches: "业务角色命中",
    permissionMatches: "权限点命中",
    permissionBindings: "权限绑定",
  },
  columns: {
    component: "组件",
    domain: "域名",
    latency: "延迟",
    note: "说明",
    application: "应用",
    portalDescription: "门户描述",
    applicationKey: "关联服务代号",
    entry: "注册表入口地址",
    sortOrder: "排序",
    grantRules: "准入规则",
    roleKey: "角色键",
    displayName: "显示名称",
    scope: "作用域",
    systemManaged: "系统内置",
    membershipCount: "成员绑定",
    applicationGrantCount: "准入规则数",
    mappingCount: "角色映射",
    permissionKey: "权限键",
    applicationOwner: "所属应用",
    resourceAction: "资源/动作",
    bindingCount: "绑定数",
    tenant: "租户",
    tenantKey: "租户键",
    organization: "组织",
    organizationKey: "组织键",
    tenantOwner: "所属租户",
    account: "用户名",
    fullName: "昵称",
    onlineStatus: "在线状态",
    mustChangePassword: "需改密码",
    failedLoginAttempts: "失败次数",
    lockedUntil: "锁定至",
    lastLoginAt: "最近登录",
    businessRole: "业务角色",
    platformRole: "平台角色",
    applicationRoles: "应用角色",
    organizationMemberships: "组织归属",
    source: "来源",
    accessible: "可访问",
    matchReason: "命中原因",
    matchedMapping: "命中映射",
    permission: "权限点",
    matchedBinding: "命中绑定",
    eventType: "事件分类",
    action: "操作动作",
    resourceType: "对象类型",
    resourceIdentifier: "审计对象",
    operator: "责任人",
    time: "发生时间",
    grantSubject: "准入主体",
    subjectValue: "主体值",
    accessLevel: "准入级别",
    subjectType: "主体类型",
    priority: "优先级",
    secretHint: "Secret 指纹",
    expiresAt: "过期时间",
    rotatedAt: "轮换时间",
    targetApplication: "对象应用",
    objectValue: "主体对象",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    tokenEndpointAuthMethod: "客户端认证方式",
    payloadSummary: "证据摘要",
    payloadJson: "原始证据 JSON",
    eventId: "审计 ID",
    recordUpdatedAt: "记录更新时间",
    loginRecordId: "登录记录 ID",
    loginTime: "登录时间",
    loginStatus: "登录结果",
    authFlow: "认证流程",
    failureReason: "失败原因",
    clientIp: "客户端 IP",
    userAgent: "UA",
    browserLanguage: "浏览器语言",
    screenResolution: "屏幕分辨率",
    terminalType: "终端类型",
    os: "操作系统",
    browser: "浏览器",
  },
  values: platformAdminIdentityValues,
  actions: {
    ...platformAdminIdentityWorkflows.actions,
    ...platformAdminIdentityUserWorkflows.actions,
  },
  drawers: {
    ...platformAdminIdentityWorkflows.drawers,
    ...platformAdminIdentityUserWorkflows.drawers,
  },
  customFields: platformAdminIdentityCustomFields,
  alerts: {
    ...platformAdminIdentityWorkflows.alerts,
    ...platformAdminIdentityUserWorkflows.alerts,
  },
  confirms: {
    ...platformAdminIdentityWorkflows.confirms,
    ...platformAdminIdentityUserWorkflows.confirms,
  },
  messages: {
    ...platformAdminIdentityWorkflows.messages,
    ...platformAdminIdentityUserWorkflows.messages,
  },
  organizationTree: platformAdminIdentityOrganizationTree,
  forms: {
    ...platformAdminIdentityWorkflows.forms,
    ...platformAdminIdentityUserWorkflows.forms,
  },
};
